export default "__VITE_ASSET__BZG$8mo1__"